
<template>
    <button 
        class="text-gray-600 hover:text-blue-500 flex items-center pr-1"
        @click="handleClick"
    >
        <i class="uil uil-atom text-2xl pr-1"></i>
        <span class="font-medium text-sm">Hera AI</span>
    </button>
</template>

<script>
export default {
    name: 'Chatbot',
    props: {
        enabled: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        handleClick() {
            if (!this.enabled) {
                this.$notify({
                    title: 'Upgrade Required',
                    message: 'To enable Hera AI Chat, you\'ll need to upgrade your plan. Please contact Hera Support by chatting with us below.',
                    type: 'warning',
                    duration: 5000
                })
                return
            }
            window.location.href = this.goToAthena('/chat')
        }
    }
}
</script>